import React from 'react'
import { ButtonGroup } from 'react-bootstrap'
import type { ButtonVariant } from 'react-bootstrap/types'
import { BusyButton } from '../BusyButton'

export type SaveCancelButtonsProps = {
  onSave?: any
  onCancel?: () => void
  saveBusyText?: string
  saveText?: string
  saveTitle?: string
  // Controls the Save button's Bootstrap variant — 'primary' by default, or 'danger' for an
  // irreversible/destructive save (e.g. a Destruct confirmation modal).
  saveVariant?: ButtonVariant
  cancelText?: string
  cancelTitle?: string
  disabled?: boolean
  /** Why Save is blocked; blocks it and shows the reason in a tooltip. */
  saveDisabledReason?: string
  /** Why Save is blocked — shown on hover and focus; pass it with `disabled`. */
  disabledReason?: string
  isBusy?: boolean
  cancelDisabled?: boolean
  cancelType?: 'button' | 'reset'
  saveType?: 'button' | 'submit'
  saveIcon?: string
  size?: 'sm' | 'lg'
}
/**
 * The default layout for save and cancel button
 */
export const SaveCancelButtons = ({
  size,
  onSave,
  onCancel,
  saveBusyText = 'Saving...',
  saveText = 'Save',
  saveVariant = 'primary',
  cancelText = 'Cancel',
  disabled,
  saveDisabledReason,
  disabledReason,
  isBusy,
  cancelDisabled = isBusy,
  cancelType,
  saveType,
  saveIcon = 'save',
  saveTitle = 'Save changes',
  cancelTitle = 'Cancel changes',
}: SaveCancelButtonsProps) => {
  return (
    <ButtonGroup size={size}>
      <BusyButton
        variant={saveVariant}
        icon={saveIcon}
        text={saveText}
        disabled={disabled}
        disabledReason={saveDisabledReason ?? (disabled ? disabledReason : undefined)}
        isBusy={isBusy}
        onClick={onSave}
        busyText={saveBusyText}
        type={saveType}
        title={saveTitle}
        aria-label={saveText ? undefined : saveTitle}
      />
      <BusyButton
        variant="outline-primary"
        type={cancelType}
        text={cancelText}
        icon="ban"
        onClick={onCancel}
        disabled={cancelDisabled}
        title={cancelTitle}
        aria-label={cancelText ? undefined : cancelTitle}
      />
    </ButtonGroup>
  )
}
